import React from "react";
import { NavLink } from "react-router-dom";
import { Home, LayoutGrid, Plus, User, MessageCircle } from "lucide-react";
import { useAuth } from "../context/AuthContext";

// Fixed bottom tab bar shown only on mobile (md:hidden). Subito.it / Vinted / Wallapop pattern.
export default function MobileBottomNav() {
  const { user } = useAuth();

  const tabs = [
    { to: "/", label: "Home", icon: Home, end: true },
    { to: "/categorie", label: "Categorie", icon: LayoutGrid },
    { to: "/pubblica", label: "Vendi", icon: Plus, cta: true },
    { to: user ? "/messaggi" : "/login", label: "Chat", icon: MessageCircle, requiresAuth: !user },
    { to: user ? "/profilo" : "/login", label: user ? "Profilo" : "Accedi", icon: User },
  ];

  return (
    <nav
      className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white border-t border-slate-200 shadow-[0_-2px_12px_rgba(0,0,0,0.05)]"
      style={{ paddingBottom: "env(safe-area-inset-bottom, 0)" }}
      data-testid="mobile-bottom-nav"
    >
      <div className="grid grid-cols-5 h-14">
        {tabs.map((t) => {
          const Icon = t.icon;
          return (
            <NavLink
              key={t.label}
              to={t.to}
              end={t.end}
              data-testid={`bottom-nav-${t.label.toLowerCase()}`}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center gap-0.5 transition-colors ${
                  t.cta
                    ? "relative"
                    : isActive
                    ? "text-[#e86a24]"
                    : "text-slate-500 hover:text-[#1d3d3a]"
                }`
              }
            >
              {t.cta ? (
                <>
                  <span className="-mt-5 w-12 h-12 rounded-full bg-[#e86a24] text-white flex items-center justify-center shadow-lg ring-4 ring-white">
                    <Icon className="w-6 h-6" strokeWidth={2.5} />
                  </span>
                  <span className="text-[10px] font-bold text-[#e86a24]">{t.label}</span>
                </>
              ) : (
                <>
                  <Icon className="w-5 h-5" strokeWidth={2} />
                  <span className="text-[10px] font-bold">{t.label}</span>
                </>
              )}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
